module.exports = __webpack_public_path__ + "media/images/unimelb_logo_small-113854d25342696ab4dcf65a131dab07.png";